import { ErrorOutline, MenuBook, SquareFoot, Warning, WarningAmber } from '@mui/icons-material';
import { Chip, Typography, styled } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { theme } from 'thermia-react-container';
import { GuideData, GuideType, IconEnum, Item, TroubleshootTagData } from '../types/types';
import BadgeList from './badgeList';

export interface GuideListProps {
  tagData: TroubleshootTagData;
  results: Item[];
  loading: boolean;
  large: boolean;
  type: GuideType;
}

const StyledResultView = styled('div')(({ theme }) => ({
  display: 'flex',
  marginBottom: 20,
  marginHorizontal: 5,
  borderColor: 'lightgrey',
  borderWidth: 1,
  padding: 10,
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'row',
  width: '100%',
  paddingLeft: 50,
  paddingBottom: 10,
  paddingTop: 10,
  paddingRight: 50,
  borderRadius: 4,
  backgroundColor: theme.palette.white.main,

  '&:hover': {
    backgroundColor: theme.palette.primaryTranslucent.main,
    cursor: 'pointer'
  }
}));

const GuideList: React.FC<GuideListProps> = ({ results, tagData, type }) => {
  const navigate = useNavigate();
  const { t } = useTranslation('troubleshoot');

  const navigateToGuide = (guide: GuideData, type: GuideType) => {
    if (type === GuideType.TROUBLESHOOT) {
      navigate(`/troubleshoot-guides/${guide.id}`);
    } else if (type === GuideType.INSTALLATIONS_AND_FUNCTIONS) {
      navigate(`/installations-functions/${guide.id}`);
    } else if (type === GuideType.PROJECTPLANNING_AND_DIMENSIONING) {
      navigate(`/projectplanning-dimensioning/${guide.id}`);
    } else {
      return;
    }
  };

  function getIcon(item: Item) {
    switch (item.icon) {
      case IconEnum.Troubleshoot:
        return <ErrorOutline style={{ fontSize: 40, color: theme.palette.primary.light }} />;
      case IconEnum.InstallationsAndFunctions:
        return <MenuBook style={{ fontSize: 40, color: theme.palette.primary.light }} />;
      case IconEnum.ProjectPlanningAndDimensioning:
        return <SquareFoot style={{ fontSize: 40, color: theme.palette.primary.light }} />;
      case IconEnum.Alarm:
        return <Warning style={{ fontSize: 40, color: theme.palette.primary.light }} />;
      case IconEnum.InverterCode:
        return <WarningAmber style={{ fontSize: 40, color: theme.palette.primary.light }} />;
      default:
        return <MenuBook style={{ fontSize: 40, color: theme.palette.primary.light }} />;
    }
  }

  return (
    <>
      {results.map((item: any, index: number) => (
        <StyledResultView
          onClick={() => {
            navigateToGuide(item, type);
          }}
          key={index}>
          <div
            style={{
              backgroundColor: 'white',
              padding: '6px',
              borderRadius: '2322px',
              border: '1px solid lightgrey',
              display: 'flex',
              justifyContent: 'center',
              alignContent: 'center'
            }}>
            {getIcon(item)}
          </div>
          <Typography variant="h5" m={3} style={{ width: '55%' }}>
            {item.heading}
          </Typography>
          <BadgeList tagData={tagData} expandable={false} limit={3} item={item} />
          {item.tags?.length < 1 && (
            <div>
              <Chip color="primary" label={t('troubleshoot.general.noTags')} key={index} />
            </div>
          )}
        </StyledResultView>
      ))}
    </>
  );
};

export default GuideList;
